import * as React from 'react';
import { DropDownFormGroup } from './FormGroups';
import { getSkoleaarList } from '../../models/SkoleAar';

export interface SkoleaarDropdownProps {
    onChange: (fieldName: string, value: string) => void;
    selectedValue: number;
}

export function SkoleaarDropdown(props: SkoleaarDropdownProps) {
    return (
        <DropDownFormGroup
            items={getSkoleaarList()}
            name='skoleaar'
            label='Skoleår'
            ingenValgtText='Vælg skoleår'
            selectedValue={props.selectedValue}
            onChange={props.onChange}
        />
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/input/SkoleaarDropDown.tsx